import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Utils from 'modules/utils';
const { linkTo } = Utils;
import connectToI18n from 'modules/i18n/connectToI18n';
import DateInput from 'components/DateInput.jsx';
import TextInputGroup from 'components/TextInputGroup.jsx';
import CitiesSelect from 'components/CitiesSelect.jsx';
import FormGroup from 'components/FormGroup.jsx';
import InputErrors from 'components/InputErrors.jsx';
import Button from 'components/Button.jsx';
import Heading from 'components/Heading.jsx';
import serializeValueFromDOMNode from 'modules/utils/serializeValueFromDOMNode';
import ProfessionalProfileCompletionCheck from './ProfessionalProfileCompletionCheck.jsx';

export class ProfessionalProfileCompletion extends React.Component {
    static propTypes = {
        completed: PropTypes.bool.isRequired,
        countries: PropTypes.array,
        citiesLoading: PropTypes.bool.isRequired,
        cities: PropTypes.array,
        formData: PropTypes.object.isRequired,
        edit: PropTypes.func.isRequired,
        submit: PropTypes.func.isRequired,
        clientErrors: PropTypes.object.isRequired,
        serverErrors: PropTypes.object.isRequired,
        showErrors: PropTypes.bool.isRequired,
        trans: PropTypes.func.isRequired,
        i18n: PropTypes.string.isRequired,
        closeModal: PropTypes.func.isRequired,
        companyUrl: PropTypes.string.isRequired,
        supportUrl: PropTypes.string.isRequired,
    };

    onChange = e => {
        const { name, value } = serializeValueFromDOMNode(e.target);
        this.props.edit(name, value);
    };

    onBirthdayChange = value => {
        this.props.edit('birthday', value);
    };

    onSubmit = e => {
        e.preventDefault();
        this.props.submit();
    };

    render() {
        if (this.props.completed) {
            return (
                <ProfessionalProfileCompletionCheck
                    closeModal={this.props.closeModal}
                    companyUrl={this.props.companyUrl}
                />
            );
        }

        const {
            citiesLoading,
            cities,
            countries,
            formData,
            supportUrl,
            clientErrors,
            serverErrors,
            showErrors,
            trans,
            i18n,
        } = this.props;

        return (
            <div>
                <Heading size={1}>{trans('user.account.authentication')}</Heading>
                <div className="kycProfessionalCompletionModal-step u-mb-4">
                    {trans('global.stepCounter', { '%current%': '1', '%total%': '2' })}
                </div>
                <div className="kycProfessionalCompletionModal-text u-mb-4">
                    {trans('user.account.proCompletion.text')}
                    <a
                        className="kycProfessionalCompletionModal-knowMore"
                        href={linkTo(supportUrl)}
                        target="_blank"
                        data-bypass
                    >
                        <span className="icon icon-info-sign" />
                        <span>{trans('payment.profile.knowMore')}</span>
                    </a>
                </div>
                <form>
                    <div className="row">
                        <FormGroup className="col-sm-6">
                            <label htmlFor="dateOfBirthDay">
                                {`${trans('global.dateOfBirth')}`}{' '}
                                <span className="required-label">{trans('global.required')}</span>
                            </label>
                            <DateInput
                                value={formData.birthday}
                                onChange={this.onBirthdayChange}
                                name="birthday"
                                inputVariant="inverse"
                                hasError={
                                    showErrors && !!(clientErrors.birthday || serverErrors.birthday)
                                }
                            />
                            <InputErrors
                                isVisible={showErrors}
                                clientErrors={clientErrors.birthday}
                                serverErrors={serverErrors.birthday}
                            />
                        </FormGroup>
                        <FormGroup className="col-sm-6">
                            <label htmlFor="nationality">
                                {trans('global.nationality')}{' '}
                                <span className="required-label">{trans('global.required')}</span>
                            </label>
                            <span
                                className={classnames(
                                    'fa-input fa-input--block fa-input--inverse fa-input--select',
                                    {
                                        'fa-input--error':
                                            showErrors &&
                                            (clientErrors.nationality || serverErrors.nationality),
                                    }
                                )}
                            >
                                <select
                                    name="nationality"
                                    id="nationality"
                                    value={formData.nationality}
                                    onChange={this.onChange}
                                >
                                    <option key="" value="">
                                        {trans('address.countryChoose')}
                                    </option>
                                    {countries.map((country, index) => {
                                        return (
                                            <option key={index} value={country.code}>
                                                {country.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </span>
                            <InputErrors
                                isVisible={showErrors}
                                clientErrors={clientErrors.nationality}
                                serverErrors={serverErrors.nationality}
                            />
                        </FormGroup>
                    </div>
                    <div className="row">
                        <TextInputGroup
                            name="street"
                            label={trans('address.numberWay')}
                            isRequired
                            className="col-sm-12"
                            inputVariant="inverse"
                            value={formData.street}
                            onChange={this.props.edit}
                            showErrors={showErrors}
                            clientErrors={clientErrors.street}
                            serverErrors={serverErrors.address && serverErrors.address.street}
                        />
                    </div>
                    <div className="row">
                        <FormGroup className="col-sm-4">
                            <label htmlFor="country">
                                {trans('address.country')}{' '}
                                <span className="required-label">{trans('global.required')}</span>
                            </label>
                            <span
                                className={classnames(
                                    'fa-input fa-input--block fa-input--inverse fa-input--select',
                                    {
                                        'fa-input--error':
                                            showErrors &&
                                            (clientErrors.country || serverErrors.country),
                                    }
                                )}
                            >
                                <select
                                    name="country"
                                    id="country"
                                    value={formData.country}
                                    onChange={this.onChange}
                                >
                                    <option key="" value="">
                                        {trans('address.countryChoose')}
                                    </option>
                                    {countries.map((country, index) => {
                                        return (
                                            <option key={index} value={country.id}>
                                                {country.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </span>
                            <InputErrors
                                isVisible={showErrors}
                                clientErrors={clientErrors.countryId}
                                serverErrors={serverErrors.countryId}
                            />
                        </FormGroup>
                        <TextInputGroup
                            name="zipCode"
                            label={trans('address.zip')}
                            isRequired
                            className="col-sm-4"
                            inputVariant="inverse"
                            value={formData.zipCode}
                            placeholder={trans('address.zip.example')}
                            showErrors={showErrors}
                            clientErrors={clientErrors.zipcode}
                            serverErrors={serverErrors.zipcode}
                            onChange={this.props.edit}
                        />
                        <FormGroup className="col-sm-4">
                            <label htmlFor="city">
                                {trans('address.city')}{' '}
                                <span className="required-label">{trans('global.required')}</span>
                            </label>
                            <CitiesSelect
                                name="cityId"
                                value={formData.cityId}
                                cities={cities}
                                citiesLoading={citiesLoading}
                                onChange={this.props.edit}
                                className={classnames('fa-input--inverse', {
                                    'fa-input--error':
                                        showErrors &&
                                        (clientErrors.cityId ||
                                            (serverErrors.address && serverErrors.address.city)),
                                })}
                            />
                            <InputErrors
                                isVisible={showErrors}
                                clientErrors={clientErrors.cityId}
                                serverErrors={serverErrors.address && serverErrors.address.city}
                            />
                        </FormGroup>
                    </div>
                    <div className="row">
                        <FormGroup className="col-sm-12">
                            <input
                                type="checkbox"
                                id="hasAcceptedSCU"
                                name="hasAcceptedSCU"
                                onChange={this.onChange}
                                checked={formData.hasAcceptedSCU}
                                className={classnames('fa-checkbox fa-checkbox--inverse', {
                                    'fa-checkbox--error':
                                        showErrors &&
                                        (clientErrors.hasAcceptedSCU ||
                                            serverErrors.hasAcceptedSCU),
                                })}
                            />
                            <label
                                htmlFor="hasAcceptedSCU"
                                dangerouslySetInnerHTML={{
                                    __html: trans('user.scu.mangoPay', {
                                        '%url%': `/${i18n}/p/terms`,
                                    }),
                                }}
                            />
                            <InputErrors
                                isVisible={showErrors}
                                clientErrors={clientErrors.hasAcceptedSCU}
                                serverErrors={serverErrors.hasAcceptedSCU}
                            />
                        </FormGroup>
                    </div>
                    <div className="kycProfessionalCompletionModal-actions">
                        <Button rounded weight="outline" onClick={this.onSubmit}>
                            {trans('global.next')}
                            <span className="icon icon-angle-right" />
                        </Button>
                    </div>
                </form>
            </div>
        );
    }
}

export default connectToI18n(ProfessionalProfileCompletion);
